import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { searchMovies, setQuery } from "../features/search/searchActions";

const HomePage = () => {
  const [text, setText] = useState("");
  const history = useHistory();
  const dispatch = useDispatch();

  const onSubmit = (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    dispatch(setQuery(text));
    dispatch(searchMovies(text));
    history.push(`/search?q=${encodeURIComponent(text)}`);
  };

  return (
    <div className="hero-section">
      <div className="hero-overlay">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              <i className="fas fa-film hero-icon"></i>
              SceneIt
            </h1>
            <p className="hero-subtitle">
              Discover movies. Plan your watchlist. Never miss a show.
            </p>
            <form className="hero-search-form" onSubmit={onSubmit}>
              <div className="hero-search-wrapper">
                <i className="fas fa-search hero-search-icon"></i>
                <input
                  type="text"
                  className="hero-search-input"
                  placeholder="Search for any movie or TV series..."
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  autoFocus
                />
                <button type="submit" className="hero-search-btn">
                  Search
                </button>
              </div>
            </form>
            <div className="hero-features">
              <span><i className="fas fa-heart"></i> Like favorites</span>
              <span><i className="fas fa-bookmark"></i> Build wishlist</span>
              <span><i className="fas fa-calendar-alt"></i> Plan watchlist</span>
              <span><i className="fas fa-users"></i> Explore cast</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
